webpackJsonp([142629428675168],{

/***/ 787:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"coralpiyu"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-f5b7b929f13421a3d271.js